//创建动态路由

import pcLayoutViewMixins from "../mixins/pcLayoutView";
import mobileLayoutViewMixins from "../mixins/mobileLayoutView";
import enums from "../utils/enums";
let __componetMap = {
  pc: {},
  mobile: {}
};
const NOT_FOUND_EXTJS = "EXTJS未能找到";

function setMap(client, name, options) {
  __componetMap[client][name] = options;
}

function getMap(client, name) {
  return __componetMap[client][name];
}

function getComponentName(client, ns) {
  return client + "-" + ns.replace(/\./g, "-");
}
function getModuleName(client, ns) {
  let info = splitNameSpace(ns);
  let serverCreateHtmlDir = dsf.config.serverCreateHtmlDir;
  return client + "/views/" + info.ns + "/" + info.file + ".ext";
}
//切割nameSpace
function splitNameSpace(nameSpace) {
  if (nameSpace.startsWith(".")) {
    nameSpace = nameSpace.substr(1);
  }
  let arr = nameSpace.split(".");
  let fileName = arr[arr.length - 1];
  let path = arr.slice(0, arr.length).join(".");
  let ns = arr.slice(0, arr.length - 1).join(".");
  return {
    path: path,
    file: fileName,
    ns: ns
  };
}

const dynamicComponent = function (namespace, client, noCache, isRouter) {
  // let cname = getComponentName(namespace);
  client = client || "pc";
  return getRemoteComponent(namespace, noCache, isRouter);
  //动态创建组件
  function getRemoteComponent(ns, noCache, isRouter) {
    return new Promise((resolve, reject) => {
      //加载组件的js、css文件
      // let _this = this;
      if (!getMap(client, ns)) {
        getComponentTemplate(ns, noCache)
          .then((response) => {
            if (!getMap(client, ns)) {
              let moduleName = getModuleName(client, ns);
              dsf.performance.start("解析" + moduleName + "布局");
              let templateStr = response.context.tpl;
              let compileFn = null;
              //如果程序已经执行过预编译则直接使用render函数
              if (response.context.render) {
                let render = response.context.render;
                let staticRenderFns = response.context.staticRenderFns || undefined;
                if (client == "mobile") {
                  let layoutViewRender = render;
                  render = function (h) {
                    var _vm = this;
                    let viewVnodes = layoutViewRender.call(_vm);
                    let vnode = h("div", {}, dsf.isArray(viewVnodes) ? viewVnodes : [viewVnodes]);
                    return vnode;
                  };
                }
                compileFn = {
                  render,
                  staticRenderFns
                };
              } else {
                if (client == "mobile") {
                  templateStr = `<div>${templateStr}</div>`;
                }
                compileFn = Vue.compile(templateStr);
              }
              let serverCreateHtmlDir = dsf.config.serverCreateHtmlDir;
              if (dsf.isUnDef(noCache)) {
                noCache = !dsf.config.setting_public_layoutviewcache;
              }
              let cache = !noCache;
              dsf.performance.end("解析" + moduleName + "布局");
              dsf.performance.start("加载" + moduleName);
              dsf.require(
                {
                  baseUrl: serverCreateHtmlDir,
                  urlArgs: cache ? null : "_t=" + dsf.cacheTime
                },
                [moduleName],
                (ext) => {
                  ext.mode = response?.context?.layout?.mode || enums.viewMode.DEVELOP;
                  ext.pageType = response?.context?.layout?.pageType;
                  ext.pageTitle = response.context.layout.title;
                  ext.name = _.camelCase(getComponentName(client, ns));
                  ext.needLogin = response.context.layout.needLogin !== false;
                  ext.pageLevel = response.context.layout.pageLevel || 1;
                  ext.isKeepAlive = response.context.layout.isKeepAlive || false;
                  let mixin = client == "mobile" ? mobileLayoutViewMixins : pcLayoutViewMixins;
                  ext.extends = mixin;
                  ext.mixins = [];
                  ext.isEs = response?.context?.layout?.isEs || false;
                  ext.esIndexName = response?.context?.layout?.esIndexName || false;
                  ext.waterMark = response.context.layout.waterMark !== false;
                  ext.metadataDict = response?.context?.metadataDict ? dsf.mix(true, {}, response?.context?.metadataDict || {}) : null;
                  ext.layoutComponentProps = response?.context?.componentProps;
                  ext.$$service = dsf.mix(true, {}, response?.context?.service || {});
                  ext.$$pageDesignId = response?.context?.layout?.designId || "";
                  let pt = dsf.config.layoutViewMixins[response.context.layout.pageType];
                  if (ext.mode === enums.viewMode.PROTOTYPE) {
                    ext.staticData = response?.context?.staticValue;
                  } else {
                    ext.staticData = null;
                  }
                  //如果是其他特殊类型表单，例如问卷
                  _.each(pt || [], (it) => {
                    //读取页面是否有其他混入配置
                    if (window.$mixins[it]) {
                      ext.mixins.push(window.$mixins[it]);
                    }
                  });
                  ext.mixins.push({
                    // template:templateStr,
                    staticRenderFns: compileFn.staticRenderFns,
                    render: function (h) {
                      if (this.$noAccess) {
                        return (
                          <div class="ds-error-wrap">
                            <div class="redict-content">
                              <img src="/static/img/platform/error-403.png" class="error-img" />
                              <p class="sub-title sub-title1">抱歉！您没有访问权限，请联系管理员</p>
                            </div>
                          </div>
                        );
                      }
                      return compileFn.render.call(this, h);
                    },
                    beforeCreate() {
                      this.$$getLayoutComponentsProps = function () {
                        return JSON.parse(ext.layoutComponentProps);
                      };
                    },
                    data() {
                      // let staticData = staticData;
                      let controls = this.$$getLayoutComponentsProps();
                      let exculds = [
                        "isDsf",
                        "hidePostNullValue",
                        "hideIgnoreValidate",
                        "isPostNull",
                        "isMergeHttp",
                        "development",
                        "designerInfo",
                        "metadataAttach",
                        "designLock",
                        "desCopyedChangeCaption",
                        "metaDataLevel",
                        "designProxy",
                        "designOnlySlot",
                        "designInductionSlot",
                        "designShowMark",
                        "designShowMarkCaption",
                        "designShowMarkInfo",
                        "designShowMarkRemove",
                        "designShowMarkDragDrop",
                        "designDisabledProps"
                      ];
                      _.each(controls, (it, k) => {
                        _.each(exculds, (prop) => {
                          delete it[prop];
                        });
                        updateControlChildrenHand(it, controls);
                      });
                      return {
                        $$esIndexName: ext.esIndexName,
                        $$isEs: ext?.isEs,
                        $$staticValue: ext.staticData ? dsf.mix(true, {}, ext.staticData) : {},
                        $$service: ext.$$service,
                        $$controls: controls,
                        $$keepAlive: ext?.isKeepAlive,
                        $$pageType: ext?.pageType,
                        $$mode: ext?.mode,
                        $$pageDesignId: ext.$$pageDesignId || "",
                        metadataDict: dsf.mix(true, {}, ext.metadataDict),
                        $$noAccess: true
                      };
                    },
                    computed: {
                      $isEs() {
                        return this._data.$$isEs;
                      },
                      $esIndexName() {
                        return this._data.$$esIndexName;
                      },
                      $controls() {
                        return this._data.$$controls;
                      },
                      $controlsMapping() {
                        let mapping = {};
                        for (let k in this._data.$$controls) {
                          let props = this._data.$$controls[k];
                          let hash = k.split("-")[1];
                          hash = hash ? "-" + hash : "";
                          let key = props.caption + hash;
                          if (props.isFormControl) {
                            key = props.metadata_fullcode + hash;
                          }
                          mapping[key] = k;
                        }
                        return mapping;
                      },
                      $service() {
                        return this?._data?.$$service;
                      },
                      $baseUrl: {
                        get() {
                          return this?.$service?.baseUrl || "";
                        },
                        set(v) {
                          this.$set(this.$service, "baseUrl", v);
                        }
                      },
                      $pageComponentProps() {
                        return this._data.$$controls[this._data.$$pageDesignId];
                      }
                    },
                    created() {},
                    destroyed() {
                      for (let k in this._data.$$controls) {
                        this._data.$$controls[k] = null;
                        delete this._data.$$controls[k];
                      }
                      this.$$getLayoutComponentsProps = null;
                    }
                  });
                  setMap(client, ns, ext);
                  dsf.global.Vue.component(ext.name, ext);
                  dsf.performance.end("加载" + moduleName);
                  // dsf.debugTimeEnd("加载" + moduleName)
                  resolve(ext);
                  response = null;
                },
                () => {
                  let msg = { message: NOT_FOUND_EXTJS };
                  dsf.layer.message(msg, false);
                  reject(msg);
                }
              );
            } else {
              resolve(getMap(client, ns));
            }
          })
          .catch((ex) => {
            reject(ex);
          });
      } else {
        resolve(getMap(client, ns));
      }
    });
  }

  //更新组件中slot指向的数据
  function updateControlChildrenHand(ctrl, controls) {
    _.each(ctrl?.slots || [], (slot) => {
      let children = _.map(slot.controls, (c) => {
        if (controls[c.designId]) {
          return controls[c.designId];
        } else {
          updateControlChildrenHand(c, controls);
          return c;
        }
      });
      slot.controls = children;
    });
  }
  function preLoadExtJs(ns, noCache) {
    let jsPath = getModuleName(client, ns);
    let id = jsPath.replace(/\.|\//g, "");
    if (!document.querySelector("#" + id)) {
      if (dsf.isUnDef(noCache)) {
        noCache = !dsf.config.setting_public_layoutviewcache;
      }
      let serverCreateHtmlDir = dsf.config.serverCreateHtmlDir;
      let url = serverCreateHtmlDir + jsPath + ".js" + (!noCache ? "" : "?_t=" + dsf.cacheTime);
      dsf.preloadScript(url, id);
    }
  }
  //获取
  function getComponentTemplate(ns, noCache) {
    preLoadExtJs(ns, noCache);
    return new Promise((resolve, reject) => {
      let response = null;
      let layoutAndStyle = null;
      getLayout(ns, noCache)
        .then((res) => {
          //加载异步组件
          response = res;
          layoutAndStyle = getLayoutAndStyleData(response ? response.data : {});
          let callback = function (com) {
            //如果组件为表单组件且为文本代理状态，则不当异步组件处理
            return !(com.isFormControl && com.textProxy);
          };
          return dsf.designer.requestAsyncComponentsByLayout(layoutAndStyle.layout, callback);
        })
        .then(() => {
          try {
            dsf.fillComponentDefaultProps(layoutAndStyle.layout);
            let props = layoutAndStyle.layout;
            let css = layoutAndStyle.css;
            props["module-name"] = ns;
            let styleEl = `<style>${css}</style>`;
            props["customCss"] = styleEl;
            // debugger
            let tplAndProps = null;
            if (!layoutAndStyle.render) {
              tplAndProps = dsf.designer.convertTemplateAndControlData(props);
            } else {
              tplAndProps = dsf.designer.convertControlData(props);
            }
            let asyncComList = [];
            let result = {
              context: {
                tpl: tplAndProps.tpl || "",
                componentProps: JSON.stringify(tplAndProps.props), //JSON.parse(JSON.stringify(tplAndProps.props)),
                layout: props,
                moduleName: ns,
                metadataDict: layoutAndStyle.metadataDict || {},
                service: layoutAndStyle.service || {},
                staticValue: layoutAndStyle.staticValue || {},
                render: layoutAndStyle.render,
                staticRenderFns: layoutAndStyle.staticRenderFns
              }
            };
            resolve(result);
          } catch (ex) {
            throw ex;
          }
        })
        .catch((ex) => {
          if (dsf.type(ex) == "error") {
            let r_notfound = /40[34]+|50.+/g;
            if (r_notfound.test(ex.message)) {
              reject();
            } else {
              dsf.error(ex);
            }
          } else {
            reject(ex);
          }
        })
        .finally(() => {
          response = null;
          layoutAndStyle = null;
        });
    });
  }

  //获取页面布局tree结构数据
  function getLayout(ns, noCache) {
    let viewinfo = splitNameSpace(ns);
    let serverCreateHtmlDir = dsf.config.serverCreateHtmlDir;
    // dsf.debugTime("加载" + viewinfo.file)
    let url = client + "/views/" + viewinfo.ns + "/" + viewinfo.file + ".layout.html";
    if (dsf.isUnDef(noCache)) {
      noCache = !dsf.config.setting_public_layoutviewcache;
    }
    let cache = !noCache;
    let p = dsf.http
      .get(
        url,
        null,
        {
          cache,
          responseType: "text"
        },
        serverCreateHtmlDir
      )
      .then((res) => {
        // dsf.debugTimeEnd("加载" + viewinfo.file)
        return res;
      });
    return p;
  }

  //获取布局数据
  function getLayoutAndStyleData(context) {
    let dom = document.createDocumentFragment();
    let div = document.createElement("div");
    div.innerHTML = context;
    dom.appendChild(div);
    //布局内容
    let layoutNode = div.querySelector("#layout");
    //css内容
    let cssNode = div.querySelector("#css");
    //元数据内容
    let metadataNode = div.querySelector("#metadatedict");
    let metadataNodeContent = metadataNode ? metadataNode.innerHTML.trim() : "";
    //微服务内容
    let serviceNode = div.querySelector("#service");
    //静态数据内容
    let staticValueNode = div.querySelector("#staticValue");
    let staticRenderFnsNode = div.querySelector("#staticRenderFns");
    //编译后的页面函数
    let staticRenderFnsCode = ["var staticRenderFns=" + (staticRenderFnsNode ? staticRenderFnsNode.innerHTML.trim() : "null").trim() + ";", "return staticRenderFns;"];
    let renderNode = div.querySelector("#render");
    let renderCode = renderNode ? renderNode.innerHTML.trim() : "";
    dom = null;
    div = null;
    let layoutFn = function () {
      var layout = JSON.parse(layoutNode ? layoutNode.innerHTML : "");
      return layout;
    };
    let cssFn = function () {
      var css = (cssNode ? cssNode.innerHTML : "").trim();
      return css;
    };
    let metadataFn = function () {
      var metadatadict = JSON.parse((metadataNodeContent ? metadataNodeContent : "{}").trim());
      return metadatadict;
    };
    let layout = dsf.fillComponentDefaultProps(layoutFn());

    let css = cssFn();
    let metadataDict = metadataFn();
    let serviceFn = function () {
      let service = new Function(["var s=", (serviceNode ? serviceNode.innerHTML : "{}").trim(), "return s"].join("\r\n"));
      return service();
    };
    let service = serviceFn();
    let staticValueFn = function () {
      var staticValue = JSON.parse(staticValueNode ? staticValueNode.innerHTML.trim() : "{}");
      return staticValue;
    };
    let staticValue = staticValueFn();
    let renderFn = null;
    let render, staticRenderFns;
    if (renderCode) {
      renderFn = new Function([renderCode].join("\n"));
      let staticRenderFnsFn = new Function(staticRenderFnsCode.join("\n"));
      render = renderFn;
      staticRenderFns = staticRenderFnsFn();
      if (staticRenderFns) {
        let arr = [];
        let fns = ["var fns=[];"];
        _.each(staticRenderFns, (fnStr, i) => {
          let fn = "var fn_" + i + "=function(){";
          fn += fnStr;
          fn += "};";
          fn += "fns.push(fn_" + i + ")";
          fns.push(fn);
        });
        fns.push("return fns;");
        try {
          let sfn = new Function(fns.join("\r\n"));
          staticRenderFns = sfn();
        } catch (ex) {
          dsf.error(ex);
        }
      }
    }
    layoutFn = null;
    cssFn = null;
    staticValueFn = null;
    serviceFn = null;
    renderCode = null;
    staticRenderFnsCode.splice(0, staticRenderFnsCode.length);
    return {
      layout,
      css,
      metadataDict,
      service,
      staticValue,
      staticRenderFns,
      render
    };
  }
};

dynamicComponent.remove = function (client, ns) {
  let name = getComponentName(client, ns);
  name = _.camelCase(name);
  //移除全局注册的组件
  delete Vue.options.components[name];
  delete __componetMap[client][ns];
  //清理掉动态加载的组件二开js
  let mname = getModuleName(client, ns);
  dsf.require.undef(mname);
};
export default dynamicComponent;
